












































































































































 class SlackManager {
  static __initStatic() {this.SCOPE = 'incoming-webhook,channels:read,channels:join,chat:write,users:read,groups:read'}
  
  
  // the any is for node until we can use tsc in nodeland
  __init() {this.cache = {}}
  __init2() {this.timeout = 5000}
  

  constructor(token) {;SlackManager.prototype.__init.call(this);SlackManager.prototype.__init2.call(this);
    this.token = token
  }

   async post(url, payload) {
    const res = await this.fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json' ,
        Authorization: `Bearer ${this.token}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify(payload)
    })
    return res.json()
  }
  async get(url) {
    const record = this.cache[url]
    if (!record) {
      const res = await this.fetch(encodeURI(url))
      const result = await res.json()
      this.cache[url] = {
        result,
        expiration: setTimeout(() => {
          delete this.cache[url]
        }, this.timeout)
      }
    } else {
      clearTimeout(record.expiration)
      record.expiration = setTimeout(() => {
        delete this.cache[url]
      }, this.timeout)
    }
    return this.cache[url].result
  }

  getConversationInfo(channelId) {
    return this.get(
      `https://slack.com/api/conversations.info?token=${this.token}&channel=${channelId}`
    )
  }

  getConversationList(types = ['public_channel']) {
    const typeStr = types.join(',')
    return this.get(
      `https://slack.com/api/conversations.list?token=${this.token}&exclude_archived=true&types=${typeStr}&limit=1000`
    )
  }

  getUserInfo(userId) {
    return this.get(
      `https://slack.com/api/users.info?token=${this.token}&user=${userId}`
    )
  }

  isValidAuthToken(token) {
    return this.get(`https://slack.com/api/auth.test?token=${token}`)
  }

  joinConversation(channelId) {
    return this.get(
      `https://slack.com/api/conversations.join?token=${this.token}&channel=${channelId}`
    )
  }

  postMessage(
    channelId,
    text,
    notificationText,
    threadTs
  ) {
    const prop = typeof text === 'string' ? 'text' : Array.isArray(text) ? 'blocks' : null
    if (!prop) throw new Error('Invalid Slack postMessage')
    const defaultPayload = {
      channel: channelId,
      unfurl_links: false,
      unfurl_media: false,
      [prop]: text,
      thread_ts: threadTs
    }
    const payload =
      prop === 'text'
        ? defaultPayload
        : {
            ...defaultPayload,
            text: notificationText
          }
    return this.post('https://slack.com/api/chat.postMessage', payload)
  }

  updateMessage(channelId, blocks, ts) {
    const newBlocks = typeof blocks === 'string' ? blocks : JSON.stringify(blocks)
    return this.post('https://slack.com/api/chat.update', {
      channel: channelId,
      blocks: newBlocks,
      ts
    })
  }
} SlackManager.__initStatic();

export default SlackManager
